import { request } from '@/api/base';
import { CurrencyCode } from '@/helpers/currency';

type PlayerPaymentsWithPagesActionType = 'deposit' | 'cashout';

interface IPlayerPaymentsWithPagesRequest {
  pageSize?: number; // DEFAULT - 20; MAX - 20;
  page: number;
  filter?: {
    currency: string;
    type: PlayerPaymentsWithPagesActionType;
    from?: string;
    to?: string;
  };
}

export interface IPlayerPaymentsWithPagesResponseData {
  id: number;
  amountCents: number;
  currency: CurrencyCode;
  action: PlayerPaymentsWithPagesActionType;
  paymentSystem: string;
  recallable: boolean;
  createdAt: string;
  finishedAt: string;
  systemName: string;
  state: 'canceled' | 'succeeded';
  brand: string;
  success: boolean;
}

interface IPlayerPaymentsWithPagesResponsePagination {
  page: number;
  perPage: number;
  totalCount: number;
}

interface IPlayerPaymentsWithPagesResponse {
  data: IPlayerPaymentsWithPagesResponseData[];
  pagination: IPlayerPaymentsWithPagesResponsePagination;
}

export const playerPaymentsWithPages = (
  data: IPlayerPaymentsWithPagesRequest,
  signal?: AbortSignal
) =>
  request<IPlayerPaymentsWithPagesResponse>({
    method: 'POST',
    url: 'player/payments/with_pages',
    data,
    signal,
  });
